import { useState } from 'react';

import {
  useGetPublicThreatHuntingOverallEvaluationQuery,
  useGetPublicThreatHuntingRunSummaryQuery,
  useGetRunSummaryPageDataQuery,
  useGetThreatHuntingOverallEvaluationQuery,
} from 'src/features/threat-hunting/threat-hunting.slice';

export const useThreatHuntingSummary = ({ runId, isPublic = false }: { runId: string; isPublic?: boolean }) => {
  const [pollingInterval, setPollingInterval] = useState(0);

  const useGetRunSummary = isPublic ? useGetPublicThreatHuntingRunSummaryQuery : useGetRunSummaryPageDataQuery;
  const useGetOverallEvaluation = isPublic
    ? useGetPublicThreatHuntingOverallEvaluationQuery
    : useGetThreatHuntingOverallEvaluationQuery;

  const {
    data: dataRunSummary,
    isLoading: isLoadingRunSummary,
    isError: isErrorRunSummary,
  } = useGetRunSummary({ runId }, { skip: !runId, pollingInterval });

  const { data: overallEvaluation, isLoading: isLoadingOverallEvaluation } = useGetOverallEvaluation(
    { runId },
    { skip: !runId },
  );

  return {
    dataRunSummary,
    isLoadingRunSummary,
    isErrorRunSummary,
    overallEvaluation,
    isLoadingOverallEvaluation,
  };
};
